import type { FPlusHighlighterProps } from '@festina-life/fplus-monaco'

import { MonacoColors } from '../monaco/colors/MonacoColors'
import { languageID } from '../worker/FPlusConfiguration'

/**
 * How the shared F-plus highlighter is built. Every consumer asks for it with
 * these props, so whichever of them happens to be first — the language setup or
 * a viewer that renders before it — the one highlighter is the same.
 */
export const fplusHighlighterProps: FPlusHighlighterProps = {
  languageId: languageID,
  additionalColors: MonacoColors,
}
